import * as React from 'react';
import { Label } from './TaskFilters.styles';
import { handleUndefinedOption } from './utils';
import { TaskStatus } from 'task-manager/types';
import { StringParam, useQueryParam } from 'use-query-params';

type StatusFilterProps = {
  handleSelectChange: (value: string, name: string) => void;
};

const statusOptions = [
  { value: TaskStatus.PENDING_WORK, label: 'To Do' },
  { value: TaskStatus.PAUSED, label: 'Paused' },
  { value: TaskStatus.RESOLVED, label: 'Done' },
];

export const StatusFilter = ({ handleSelectChange }: StatusFilterProps) => {
  const [status] = useQueryParam('status', StringParam);
  return (
    <span key={'statusFilter'}>
      <Label>Status</Label>
      <select
        aria-label="status dropdown"
        name="status"
        value={handleUndefinedOption(status)}
        onChange={event => handleSelectChange(event.target.value, event.target.name)}
      >
        <option value={TaskStatus.ALL}>All</option>
        {statusOptions.map(({ value, label }) => (
          <option value={value} key={value}>
            {label}
          </option>
        ))}
      </select>
    </span>
  );
};
